import {Deserializable} from "./deserializable.model";

export class JobType {

    job_type_id: number;
    job_type_name: string;
    job_type_description: string;
    is_active: string;



  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): JobType {
    Object.assign(this, input);

    return this;
  }


}
